import { useEffect, useState } from "react";

import { ForeignNationalsAPI } from "@/api/foreignNationals";

/** Whether the client has a portal login: `null` until known or on error. */
export type PortalState = "active" | "off" | "none" | null;

/** What the portal chip means for the firm's requests, for its tooltip. */
export const portalHint = (state: PortalState): string | null => {
  if (state === "active")
    return "The client signs in to the portal to answer requests and upload files.";
  if (state === "off")
    return "Portal login is turned off. Intake forms and requests still reach the client as email links.";
  if (state === "none")
    return "No portal login yet. Intake forms and requests still reach the client as email links.";
  return null;
};

/** `refreshKey`: refetch when it changes (e.g. after an invite or turn-off). */
export const usePortalState = (
  clientId: string,
  hasEmail: boolean,
  refreshKey?: number
): PortalState => {
  const [state, setState] = useState<PortalState>(null);
  useEffect(() => {
    let live = true;
    ForeignNationalsAPI.getAuthStatus(clientId)
      .then((s) => {
        if (!live) return;
        setState(!s.exists ? "none" : s.disabled ? "off" : "active");
      })
      .catch(() => live && setState(null));
    return () => {
      live = false;
    };
  }, [clientId, hasEmail, refreshKey]);
  return state;
};
